import { render, staticRenderFns } from "./water-usage-tile.vue?vue&type=template&id=485d1528&"
import script from "./water-usage-tile.vue?vue&type=script&lang=ts&"
export * from "./water-usage-tile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports